import * as React from 'react'
import { useSelector } from 'react-redux'
import { UserPermission } from '../current/types'
import { AppState } from '../store'
import { includesAll, includesSome, matchesAll, matchesSome } from '../utils/array'

// Use these helpers for a more concise way to check permissions
export function usePermissions() {
  const permissions = useSelector((s: AppState) => s.current.user.permissions)
  const includesAllPermissions = React.useCallback(
    (...requiredPermissions: UserPermission[]): boolean => includesAll(permissions, ...requiredPermissions),
    [permissions]
  )

  const includesSomePermissions = React.useCallback(
    (...anyPermissions: UserPermission[]): boolean => includesSome(permissions, ...anyPermissions),
    [permissions]
  )

  const matchesAllPermissions = React.useCallback(
    (pattern: string | RegExp) => matchesAll(permissions, pattern),
    [permissions]
  )

  const matchesSomePermissions = React.useCallback(
    (pattern: string | RegExp) => matchesSome(permissions, pattern),
    [permissions]
  )

  return {
    permissions,
    includesAllPermissions,
    includesSomePermissions,
    matchesAllPermissions,
    matchesSomePermissions
  }
}
